// src/App.js
import React, { useState, useEffect } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import Dashboard from "./Dashboard";
import LandingPage from "./LandingPage";
import { VanProvider } from "./contexts/VanContext";
import { GroomerProvider } from "./contexts/GroomerContext";
import { initializeNotificationsAfterLogin } from "./utils/notificationUtils";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentView, setCurrentView] = useState('landing');

  // On mount, check for a token in localStorage
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsAuthenticated(true);
      // No need to initialize notifications here as it's handled in handleLoginSuccess
      // This prevents duplicate subscription records in the database
    }
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    // Safely initialize notifications after successful login
    // This prevents the iOS refresh loop by only running after authentication
    initializeNotificationsAfterLogin();
  };

  const handleRegisterClick = () => {
    setCurrentView('register');
  };

  const handleForgotPasswordClick = () => {
    setCurrentView('forgot');
  };

  const handleBackToLogin = () => {
    setCurrentView('login');
  };
  
  const handleStaffLoginClick = () => {
    setCurrentView('login');
  };
  
  const handleBackToHome = () => {
    setCurrentView('landing');
  };

  // Helper function to render the appropriate auth screen
  const renderAuthScreen = () => {
    switch (currentView) {
      case 'landing':
        return <LandingPage onStaffLoginClick={handleStaffLoginClick} />;
      case 'register':
        return <Registration 
          onBackToLogin={handleBackToLogin} 
          onRegistrationSuccess={handleBackToLogin}
        />;
      case 'forgot':
        return <ForgotPassword onBackToLogin={handleBackToLogin} />;
      case 'login':
        return (
          <Login 
            onLoginSuccess={handleLoginSuccess}
            onRegisterClick={handleRegisterClick}
            onForgotPasswordClick={handleForgotPasswordClick}
            onBackToHome={handleBackToHome}
          />
        );
      default:
        return <LandingPage onStaffLoginClick={handleStaffLoginClick} />;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div>
        {isAuthenticated ? (
          <VanProvider>
            <GroomerProvider>
              <Dashboard />
            </GroomerProvider>
          </VanProvider>
        ) : (
          renderAuthScreen()
        )}
      </div>
    </LocalizationProvider>
  );
}

export default App;
